import type WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { BridgeToApiPreviewEnvironmentStatusMessage } from '../../types/bridge-to-api-messages.js';
import type { PreviewEnvironmentLogTails } from '../manager/types.js';

/**
 * Emit `preview_environment_status` to the bridge WebSocket (persisted + broadcast by Bridge DO).
 * Deferred so start/stop/exit paths don't block the event loop on JSON.stringify + ws.send.
 */
export function sendPreviewEnvironmentStatus(
  getWs: () => WebSocket | null,
  environmentId: string,
  status: string,
  options?: { detail?: string; tails?: PreviewEnvironmentLogTails },
): void {
  const payload: BridgeToApiPreviewEnvironmentStatusMessage = { type: 'preview_environment_status', environmentId, status };
  if (options?.detail) payload.detail = options.detail;
  if (options?.tails) {
    payload.stdoutTail = options.tails.stdout;
    payload.stderrTail = options.tails.stderr;
  }
  setImmediate(() => {
    const ws = getWs();
    if (!ws) return;
    sendWsMessage(ws, payload);
  });
}
